import type { HotelProduct } from '@/entities/hotel';
import type { Product } from '@/entities/product';
import { getCheapestItem } from '@/shared/lib/price';
import type { SerpProduct } from '../model/types';

/**
 * Схлопывает плоскую выдачу поиска в карточки: один отель — одна карточка со своими продуктами.
 *
 * Порядок отелей сохраняется — это порядок сортировки выдачи. Отели без продуктов
 * отбрасываются: показывать нечего и цены у карточки не будет.
 */
export function toSerpProducts(
  hotels: readonly HotelProduct[],
  productsByHotel: ReadonlyMap<number, readonly Product[]>,
): SerpProduct[] {
  const serpProducts: SerpProduct[] = [];

  for (const hotel of hotels) {
    const products = productsByHotel.get(hotel.id);

    if (!products?.length) continue;

    // Сортируем копию: массивы принадлежат поиску и переиспользуются между порциями результатов.
    serpProducts.push(
      toSerpProduct(
        hotel,
        [...products].sort((left, right) => left.price - right.price),
      ),
    );
  }

  return serpProducts;
}

export function toSerpProduct(hotel: HotelProduct, products: Product[]): SerpProduct {
  return { hotel, products, cheapProduct: getCheapestItem(products) };
}

export function hasSerpProducts({
  hotels,
  productsByHotel,
}: {
  hotels: readonly HotelProduct[];
  productsByHotel: ReadonlyMap<number, readonly Product[]>;
}): boolean {
  return hotels.some((hotel) => Boolean(productsByHotel.get(hotel.id)?.length));
}
